import axios from 'axios';
import config from '../config';
import {
    redirect,
} from './navigation';
import {
    getCsrfToken,
} from './csrf';
import {
    getCspToken,
} from './csp';

export const MOCK_TEST_API = 'mockTestApi';
export const BACKEND = 'backend';
export const X_ORIGIN_HEADER = 'karl-app.http';

// Explicitly set XHR header to mark all requests as XMLHttpRequest
function apiRequiresXhrHeader(api) {
    return [
        BACKEND,
    ].includes(api);
}

// Handle 401 Unauthorized network errors.
export async function interceptorAuthError(error) {
    const isUnauthorized = error.response?.status === 401;
    const redirectToLocation = error?.response?.headers?.['x-location'];

    if (isUnauthorized && (redirectToLocation !== undefined)) redirect(redirectToLocation);

    return Promise.reject(error);
}

export function xOriginHeaderInterceptor(axiosConfig) {
    // eslint-disable-next-line no-param-reassign
    axiosConfig.headers['X-Origin'] = X_ORIGIN_HEADER;
    return axiosConfig;
}

export function apiEndpoint({
    api,
    endpoint,
    options = {},
}) {
    const axiosOptions = {
        baseURL: `${config.api[api].url}/${endpoint}`,
        timeout: 60000,
        headers: {
            'X-Origin': `${config.xOriginHeader}`,
            'X-CSRF-TOKEN': getCsrfToken(),
            'X-CSP-TOKEN': getCspToken(),
        },
        ...options,
    };

    if (apiRequiresXhrHeader(api)) {
        axiosOptions.headers = { ...axiosOptions.headers, 'X-Requested-With': 'XMLHttpRequest' };
    }

    const axiosInstance = axios.create(axiosOptions);

    axiosInstance.interceptors.response.use(response => response, interceptorAuthError);
    axiosInstance.interceptors.request.use(axiosConfig => xOriginHeaderInterceptor(axiosConfig));

    return axiosInstance;
}

export function apiResource(type, body, id) {
    const data = {
        type,
        attributes: body,
    };
    if (id) {
        data.id = id;
    }
    return {
        data,
    };
}

export function apiErrorShouldBeReported(error) {
    return error.response ? error.response.status !== 404 : true;
}
